export enum LicenceTypes {
    ADULT = "ADULTE",
    YOUNG = "JEUNE",
    DIRECTON = "DIRIGEANT",
}